module.exports = __webpack_public_path__ + "img/bx09-5.4c66a63b.jpg";